// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"defaultVendors-node_modules_datadog_browser-rum_esm_boot_startRecording_js":"43a5046b","defaultVendors-node_modules_datadog_browser-rum_esm_domain_profiling_profiler_js":"84a05706"}[chunkId] + ".chunk.js";
};